import { InlineFeedback } from '../../feedback/index.js';
import { useEffect, useId, useRef, useState } from 'react';

// Keep a gesture in local state, then commit once so Undo restores its starting value.
export function ContentEditorRangeField({ label, value, min, max, step = 1, onCommit, disabled, resetKey }) {
  const id = useId();
  const [draft, setDraft] = useState(String(value));
  const [error, setError] = useState('');
  const cancelled = useRef(false);
  const cancel = () => { cancelled.current = true; setDraft(String(value)); setError(''); };
  const change = event => { cancelled.current = false; setDraft(event.target.value); setError(''); };
  useEffect(() => { setDraft(String(value)); setError(''); }, [value, resetKey, disabled]);
  const commit = () => {
    if (disabled || cancelled.current) return;
    const number = Number(draft);
    if (!draft.trim() || !Number.isFinite(number) || number < min || number > max) {
      setError(`Enter a value from ${min} to ${max}.`);
      return;
    }
    setError('');
    if (number !== Number(value)) onCommit(number);
  };
  return <div className="mts-editor-range-field">
    <label htmlFor={id}>{label}</label>
    <input type="range" aria-label={`${label} slider`} min={min} max={max} step={step} disabled={disabled} value={Number.isFinite(Number(draft)) ? Math.max(min, Math.min(max, Number(draft))) : value} onChange={change} onPointerCancel={cancel} onPointerUp={commit} onKeyDown={event => { if (event.key === 'Escape') { event.preventDefault(); cancel(); } }} onKeyUp={event => { if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown'].includes(event.key)) commit(); }} onBlur={commit}/>
    <input id={id} type="number" min={min} max={max} step={step} disabled={disabled} value={draft} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} onChange={change} onBlur={commit} onKeyDown={event => { if (event.key === 'Escape') { event.preventDefault(); cancel(); } else if (event.key === 'Enter') { event.preventDefault(); commit(); } }}/>
    {error ? <InlineFeedback variant="error" id={`${id}-error`} role="status">{error}</InlineFeedback> : null}
  </div>;
}
